import CustomerView from "./CustomerView.vue"
import CustomerJobList from "./CustomerJobList.vue"
import CustomerAssetList from "./CustomerAssetList.vue"
import CustomerProjectList from "./CustomerProjectList.vue"
import CustomerProjectJobList from "./CustomerProjectJobList.vue"


const base = "/customer"

export default [
    {
        path: base + "/:uuid",
        name: "customerdetailform",
        props: true,
        component: CustomerView
    },
    {
        path: base + "/:uuid/jobs",
        name: "customerjoblist",
        props: true,
        component: CustomerJobList
    },
    {
        path: base + '/:uuid/assets',
        name: "customerassetlist",
        props: true,
        component: CustomerAssetList
    },
    {
        path: base + '/:customerUuid/projects/:customerProjectUuid?',
        name: "customerprojectlist",
        props: true,
        component: CustomerProjectList
    },
    {
        path: base + '/:customerUuid/projects/:customerProjectUuid/jobs',
        name: "customerprojectjoblist",
        props: true,
        component: CustomerProjectJobList
    },

]
